
import { Vue, Component } from 'vue-property-decorator';
import Welcome from '../../../public/welcome.svg';
import manager from '@/common/utils/permission-manager';

@Component({})
export default class Home extends Vue {
  visible = true;

  visibleType = false;

  value = '';

  svg = Welcome;

  start() {
    // this.visibleType = true;
    // this.value = '';
    // 黑卡角色
    const arr = [
      'menu:operation-workbench',
      'shop:list',
      'menu:car-shop-list',
      'menu:supply-sales-order-list',
      'menu:purchase-order-list',
      'menu:supply-distributor-manage',
      'menu:supply-product-manage',
      'menu:supply-supplier-manage',
      'menu:supply-platform-sale-order',
      'menu:supply-platform-purchase-order',
    ];

    manager
      .send(arr)
      .subscribe((permissions: any) => {
        const type = 'menu:operation-workbench'; // 工作台
        const type_shop = 'shop:list'; // 店铺列表
        const type_car = 'menu:car-shop-list'; // 二手车列表
        const type_supply_sales_order = 'menu:supply-sales-order-list'; // 销售单列表
        const type_purchase_order = 'menu:purchase-order-list'; // 采购单列表
        const type_supply_distributor = 'menu:supply-distributor-manage'; // 经销商管理
        const type_supply_product = 'menu:supply-product-manage'; // 商品管理
        const type_supply_supplier = 'menu:supply-supplier-manage'; // 供应商管理
        const type_supply_platform_sale = 'menu:supply-platform-sale-order'; // 平台销售单
        const type_supply_platform_purchase = 'menu:supply-platform-purchase-order'; // 平台采购单
        if (Object.keys(permissions).length > 0) {
          if (permissions[type]) {
            this.$router.push({
              name: 'workbenches.index',
            });
          } else if (permissions[type_shop]) {
            this.$router.push({
              name: 'main.shop.list',
            });
          } else if (permissions[type_car]) {
            this.$router.push({
              name: 'car.index',
            });
          } else if (permissions[type_supply_sales_order]) {
            this.$router.push({
              name: 'salesOrderList',
            });
          } else if (permissions[type_purchase_order]) {
            this.$router.push({
              name: 'purchaseOrderList',
            });
          } else if (permissions[type_supply_distributor]) {
            this.$router.push({
              name: 'distributorList',
            });
          } else if (permissions[type_supply_product]) {
            this.$router.push({
              name: 'goodsList',
            });
          } else if (permissions[type_supply_supplier]) {
            this.$router.push({
              name: 'supplierManagement',
            });
          } else if (permissions[type_supply_platform_sale]) {
            this.$router.push({
              name: 'platformSalesOrder',
            });
          } else if (permissions[type_supply_platform_purchase]) {
            this.$router.push({
              name: 'platformPurchaseOrder',
            });
          }
        }
        // name: 'workbenches.index',
        // name: 'main.shop.list',
      });
    // 二手车角色

    // 双角色
  }
  changeRole() {}
}
